/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * One remote_session_issuer field whose value differs between the source and target of a consolidation, with both sides' values.
 */
export type IssuerFieldMismatch = {
  /**
   * The differing field's name: issuer, token_endpoint, authorization_endpoint, oidc, passthrough, or scopes_supported.
   */
  field: string;
  /**
   * The source issuer's value for a scalar field, rendered as a string. Null when the source leaves the field unset, and null for a list-valued field.
   */
  sourceValue?: string | undefined;
  /**
   * The source issuer's entries for a list-valued field. Absent for a scalar field, and absent when the source's list is empty.
   */
  sourceValues?: Array<string> | undefined;
  /**
   * The target issuer's value for a scalar field, rendered as a string. Null when the target leaves the field unset, and null for a list-valued field.
   */
  targetValue?: string | undefined;
  /**
   * The target issuer's entries for a list-valued field. Absent for a scalar field, and absent when the target's list is empty.
   */
  targetValues?: Array<string> | undefined;
};

/** @internal */
export const IssuerFieldMismatch$inboundSchema: z.ZodMiniType<
  IssuerFieldMismatch,
  unknown
> = z.pipe(
  z.object({
    field: z.string(),
    source_value: z.optional(z.string()),
    source_values: z.optional(z.array(z.string())),
    target_value: z.optional(z.string()),
    target_values: z.optional(z.array(z.string())),
  }),
  z.transform((v) => {
    return remap$(v, {
      "source_value": "sourceValue",
      "source_values": "sourceValues",
      "target_value": "targetValue",
      "target_values": "targetValues",
    });
  }),
);

export function issuerFieldMismatchFromJSON(
  jsonString: string,
): SafeParseResult<IssuerFieldMismatch, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => IssuerFieldMismatch$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'IssuerFieldMismatch' from JSON`,
  );
}
